import { Injectable } from '@angular/core';
import { APP_ALLOWED_MODULES, CompanyPortalServices } from '../config/appConfig';
import { CompanyDetailsInterface } from '../../companies/interfaces/company-details.interface';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { FeatureFlagsService } from '../../../services/feature-flags.service';
import { ConfigService } from '../../../services/config/config.service';
import { CompaniesService } from '../../companies/services/companies.service';

@Injectable({
    providedIn: 'root',
})
export class IdentityService {
    public company: CompanyDetailsInterface;
    public isCustomerzone: boolean;
    public isMdr: boolean;
    private companyLoadedSubj = new BehaviorSubject<boolean>(false);
    public companyLoaded$ = this.companyLoadedSubj.asObservable();

    constructor(
        private readonly featureFlagService: FeatureFlagsService,
        private readonly configService: ConfigService,
        private readonly companiesService: CompaniesService,
    ) {}

    public get companyLoaded() {
        return this.company !== null;
    }

    /** Be careful of stale company data **/
    public async setCompany(company: CompanyDetailsInterface) {
        this.company = company;

        if (company.portals?.includes(CompanyPortalServices.Ti) && company.portals?.length === 1) {
            window.location.href = this.featureFlagService.get('ti_redirect_url');
            return;
        }

        if (company.portals?.includes(CompanyPortalServices.Customerzone)) {
            this.isCustomerzone = true;
        }
        if (this.company.portals?.includes(CompanyPortalServices.Mdr)) {
            this.isMdr = true;
        }

        this.companyLoadedSubj.next(true);
    }

    public isCompanySelectorVisible(): boolean {
        return <boolean>this.company.details?.configuration.features.enableCompanySelector;
    }

    public getPortalType(): CompanyPortalServices {
        const company = this.company;

        if (this.configService.isCustomerzonePortal) {
            return CompanyPortalServices.Customerzone;
        }

        if (!company?.portals) {
            return CompanyPortalServices.Mdr;
        }

        return company?.portals[0];
    }

    public isModuleAvailable(module: string): boolean {
        const moduleIndex = APP_ALLOWED_MODULES.findIndex((path) => path.name === module);
        return APP_ALLOWED_MODULES[moduleIndex]?.allowed.includes(this.getPortalType());
    }
}
